export class AlgoritmType {
    public static readonly yandex = "Yandex";
    public static readonly manual = "Manual";
}